import { calculateBoxSizes as r } from "./ghl-ui.es1221.js";
import { freeze as t } from "./ghl-ui.es1554.js";
var s = function() {
  function i(o) {
    var e = r(o);
    this.target = o, this.contentRect = e.contentRect, this.borderBoxSize = t([e.borderBoxSize]), this.contentBoxSize = t([e.contentBoxSize]), this.devicePixelContentBoxSize = t([e.devicePixelContentBoxSize]);
  }
  return i;
}();
export {
  s as ResizeObserverEntry
};
